import { FilterField, Position } from 'coreOld/enums';
import { addressesService } from 'coreOld/services';
import { corporateRegionService, corporateUserService } from 'corporate/services';
import { companiesService } from 'partsOld/services';

import { profileTypeOptions } from './constants';
import { dateOptions } from './dates';

export const filtersConfig = [
  {
    name: 'updatedAt',
    type: FilterField.DATE,
    minWidth: 150,
    props: {
      options: dateOptions,
    },
  },
  {
    name: 'quotedByUserId',
    type: FilterField.AUTOCOMPLETE,
    minWidth: 150,
    props: {
      placeholder: 'Quoted By User',
      getOptions: corporateUserService.getCorporateUsersAutocomplete,
      requestPayload: {
        filters: {
          status: 'active',
        },
      },
      isMulti: true,
    },
  },
  {
    name: 'priceSourceType',
    type: FilterField.SELECT,
    minWidth: 150,
    props: {
      options: profileTypeOptions,
      placeholder: 'Profile Type',
      isMulti: true,
    },
  },
  {
    name: 'customerCompanyId',
    type: FilterField.AUTOCOMPLETE,
    minWidth: 150,
    props: {
      placeholder: 'Customer',
      getOptions: companiesService.getManyAutocomplete,
      isMulti: true,
      requestPayload: {
        filters: {
          quote: {
            companyType: 'customer',
          },
        },
      },
    },
  },
  {
    name: 'quoteUserAddressId',
    type: FilterField.AUTOCOMPLETE,
    minWidth: 150,
    props: {
      placeholder: 'Location',
      getOptions: addressesService.getManyAutocomplete,
      isMulti: true,
      requestPayload: {
        filters: {
          locationType: 'company_location',
        },
      },
    },
  },
  {
    name: 'quoteUserCorporateRegionId',
    type: FilterField.AUTOCOMPLETE,
    minWidth: 150,
    props: {
      placeholder: 'Region',
      getOptions: corporateRegionService.getRegionsAutocomplete,
      isMulti: true,
    },
  },
  {
    name: 'query',
    type: FilterField.SEARCH,
    minWidth: 150,
    flex: 100,
    border: Position.RIGHT,
  },
];
